export default {
  copy: null,
  href: {
    url: 'http://www.bbc.co.uk/news',
    linktype: 'url',
    fieldtype: 'multilink',
    cached_url: 'http://www.bbc.co.uk/news',
  },
  target: null,
  component: 'a-link-v2',
}
